var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn_white btn_autocreatefooter"},[_vm._v("\n    保存して閉じる\n")])}
var staticRenderFns = []

export { render, staticRenderFns }